<template>
  <div class="area-tabs">
    <button
      type="button"
      class="area-tab"
      :class="{ active: modelValue === 'atendimento' }"
      @click="$emit('update:modelValue', 'atendimento')"
    >
      Atendimento
    </button>
    <button
      type="button"
      class="area-tab"
      :class="{ active: modelValue === 'gestao' }"
      @click="$emit('update:modelValue', 'gestao')"
    >
      Gestão
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "atendimento",
      validator: (value) => ["atendimento", "gestao"].includes(value)
    }
  },
  emits: ["update:modelValue"]
};
</script>

<style lang="scss" scoped>
$lila-primary: #4f3f82;
$lila-accent: #9a397d;

.area-tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #eceaf3;
  border-radius: 999px;
  padding: 4px;
  margin: 24px 0 20px;
}
.area-tab {
  border: none;
  background: transparent;
  color: $lila-primary;
  font-size: 15px;
  font-weight: 600;
  padding: 9px 28px;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
  transition:
    background 0.25s ease,
    color 0.25s ease;
}

.area-tab.active {
  background: $lila-accent;
  color: #ffffff;
}
</style>
